import React from 'react';
import styled from 'styled-components';

import { Link, useStaticQuery, graphql } from 'gatsby';

import config from '../../utils/config';
import { Heading, SanityImage, Markdown } from '../elements';
import SubscribeForm from '../forms/SubscribeForm';
import Social from './Social';

const Section = styled.footer`
  background-color: ${(props) => props.theme.backgroundColorLight} !important;
  .has-opacity {
    opacity: 0.7;
  }
  .image {
    width: 181px;
    height: 70.31px;
  }
`;

const BottomWrapper = styled.div`
  background-color: ${(props) => props.theme.darkShades};
`;

const CopyRightWrapper = styled.p`
  line-height: 30px;
  a {
    color: ${(props) => props.theme.lightShades};
    :hover {
      color: ${(props) => props.theme.mainBrandColor};
    }
  }
`;

const query = graphql`
  query footerQuery {
    sanityGlobals {
      logoImage {
        asset {
          _id
          gatsbyImageData(width: 500, placeholder: BLURRED)
        }
      }
      twitter
      facebook
      linkedin
      instagram
    }
    sanityFooter {
      description
      subscribeTitle
      subscribeDescription
      subscribeTerms
      footerColumn {
        _key
        heading
        footerOption {
          _key
          name
          linkTo {
            current
          }
        }
      }
    }
  }
`;

const Footer = () => {
  const { sanityGlobals, sanityFooter } = useStaticQuery(query);

  return (
    <>
      <Section className="section">
        <div className="container">
          <div className="columns">
            <div className="column is-4">
              {sanityGlobals.logoImage && (
                <Link className="mb-4 image" to="/">
                  <SanityImage
                    gatsbyImageData={
                      sanityGlobals.logoImage.asset.gatsbyImageData
                    }
                    alt={config.siteName}
                  />
                </Link>
              )}
              <Markdown className="has-text-grey-dark">
                {sanityFooter.description}
              </Markdown>
            </div>
            {sanityFooter.footerColumn &&
              sanityFooter.footerColumn.map((el) => (
                <div className="column is-4" key={el._key}>
                  <Heading dark className="is-size-4 mb-5 is-uppercase">
                    {el.heading}
                  </Heading>
                  <ul>
                    {el.footerOption &&
                      el.footerOption.map((item) => (
                        <li className="mb-4" key={item._key}>
                          <Link
                            to={`/${item.linkTo.current}`}
                            className="has-text-grey-dark has-opacity"
                          >
                            {item.name}
                          </Link>
                        </li>
                      ))}
                  </ul>
                </div>
              ))}
          </div>
        </div>
      </Section>
      <SubscribeForm data={sanityFooter} />

      <BottomWrapper className="py-5 bottom section">
        <div className="container">
          <div className="columns is-vcentered">
            <div className="column is-4">
              <Social data={sanityGlobals} />
            </div>
            <div className="column is-8">
              <CopyRightWrapper className="has-text-white">
                ©Cap Ex Associates Tax Ltd |{' '}
                <Link to="/terms-and-conditions/">Terms & Conditions </Link> |{' '}
                <Link to="/privacy-policy">Privacy Policy </Link>|{' '}
                <Link to="/cookie-policy/">Cookie Policy</Link> |{' '}
                <Link to="/sitemap/sitemap-index.xml">Sitemap</Link>
              </CopyRightWrapper>
            </div>
          </div>
        </div>
      </BottomWrapper>
    </>
  );
};

export default Footer;
